import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function GettingStartedIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12 2l2.92 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 7.08-1.01L12 2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></path>
    </SvgIcon>
  );
}

export default GettingStartedIcon;
